// extracted by mini-css-extract-plugin
export var checkboxContainer = "checkbox-module--checkbox-container--dq2qz";
export var checkmark = "checkbox-module--checkmark--uhbsW";